import React from 'react';
import { Table, Button } from 'rbx';
import styled from 'styled-components';
import moment from 'moment';
import { first } from 'lodash';
import ReactTooltip from 'react-tooltip';

const Element = styled.div``;
const Element2 = styled.div``;

const List = ({ fees, users = [], onHandleOverride, onResetToDefault }) => (
  <>
    {fees?.map(item => {
      const updatedBy =
        item.order_fee_override &&
        item.order_fee_override.audit &&
        item.order_fee_override.audit.updated_by;
      const userMatch = users.filter(u => u.user_id === updatedBy);
      const user = userMatch.length !== 0 ? first(userMatch) : undefined;

      return (
      <Table.Row key={item.order_fee.fee_id}>
        <Table.Cell>{item.order_fee.name}</Table.Cell>
        <Table.Cell>
          {item.order_fee && item.order_fee_override
            ? item.order_fee_override.display
            : item.order_fee.display}
        </Table.Cell>
        <Table.Cell>
          <Element>{item.order_fee.sale_method}</Element>
        </Table.Cell>
        <Table.Cell>
          <Element>{item.order_fee.type}</Element>
        </Table.Cell>
        <Table.Cell>
          {item.order_fee.type !== 'PERCENTAGE' ? `$` : ''}
          {item.order_fee_override && item.order_fee_override.override
            ? parseFloat(item.order_fee_override.value).toFixed(2)
            : parseFloat(item.order_fee.value).toFixed(2)}
        </Table.Cell>
        <Table.Cell>{item.order_fee.tax}</Table.Cell>
        <Table.Cell>
          {parseFloat(item.order_fee.tax_value).toFixed(2)}%
        </Table.Cell>

        <Table.Cell>
          {item.order_fee && item.order_fee.is_payment_gateway_fee === true
            ? 'Yes'
            : 'No'}
        </Table.Cell>
        <Table.Cell>
          {item.order_fee && item.order_fee.is_kravein_charge === true
            ? 'Yes'
            : 'No'}
        </Table.Cell>
        <Table.Cell>
          <Element>
            {item.order_fee_override && item.order_fee_override.override
              ? parseFloat(
                  item.order_fee_override.minimum_order_amount,
                ).toFixed(2)
              : '-'}
          </Element>
        </Table.Cell>
        <Table.Cell>
          <Element>{item.order_fee.applies_to}</Element>
        </Table.Cell>
        <Table.Cell>
          {user ? (
            <React.Fragment>
              <p data-tip={user.full_name}>{user.full_name}</p>
              <ReactTooltip place="top" type="dark" effect="float">
                <span>
                  <p>email: {user.email}</p>
                  <p>objectId: {user.user_id}</p>
                </span>
              </ReactTooltip>
            </React.Fragment>
          ) : (
            updatedBy
          )}
        </Table.Cell>
        <Table.Cell>
          {item.order_fee_override &&
          item.order_fee_override.audit &&
          item.order_fee_override.audit.updated_at
            ? moment(item.order_fee_override.audit.updated_at).format('lll')
            : '-'}
        </Table.Cell>
        <Table.Cell>
          <Element2>
            <Button.Group hasAddons>
              <Button color="primary" onClick={() => onHandleOverride(item)}>
                Override
              </Button>
              {item.order_fee_override && item.order_fee_override.override && (
                <Button
                  onClick={() =>
                    onResetToDefault({ fee_id: item.order_fee.fee_id })
                  }
                >
                  Reset
                </Button>
              )}
            </Button.Group>
          </Element2>
        </Table.Cell>
      </Table.Row>
      );
    })}
  </>
);

export default List;
